import type { EmployeeShortName } from './employee-short-name';

export function employeeShortNamesOrAll(shortNames: EmployeeShortName[], employees: string[]): string[] {
  const list = shortNames.filter((v) => employees.includes(v.uuid)).map((v) => v.name);
  if (list.length > 1 && list.length === shortNames.length) {
    return ['alt personale'];
  }
  return list;
}
